module.exports = __webpack_public_path__ + "img/H2.24823707.png";